(function () {
  if (
    document.body.classList.contains('template_product-no-a') &&
    window.location.search.indexOf('view=product-no-a-v2') === -1
  ) {
    window.location.replace(
      window.location.pathname + '?view=product-no-a-v2' + window.location.hash
    );
    return;
  }

  if (
    document.body.classList.contains('template_product-no-a-v2') &&
    window.location.search.indexOf('view=product-no-a-v2') !== -1
  ) {
    window.history.replaceState(null, '', window.location.pathname + window.location.hash);
  }
})();

const plusButtons = document.querySelectorAll('.ct-Plue');

plusButtons.forEach(button => {
    button.addEventListener('click', function(e) {
        if (window.innerWidth < 768) {
            
            const parentMedia = this.closest('.product-card__media');
            const isAlreadyActive = parentMedia.classList.contains('size-active');
            document.querySelectorAll('.product-card__media').forEach(media => {
                media.classList.remove('size-active');
            });
            if (!isAlreadyActive) {
                parentMedia.classList.add('size-active');
            }
        }
    });
});